import { useTranslation } from 'react-i18next'

import { QA_NAME_ATTACH_BTN, QA_NAME_CANCEL_BTN } from '../../../constants/qa'
import { TableRowActions } from '../../Table'
import { TableModal } from '../../TableModal'

import { QA_NAME_ATTACH_TASKS_MODAL } from './AttachTasksModal.constants'
import { useAttachTasksModal } from './AttachTasksModal.hooks'
import { AttachTasksModalTableRow } from './AttachTasksModalTableRow'

import * as styles from './AttachTasksModal.module.css'

import ActivityIcon from '../../../icons/task.svg'

function AttachTasksModal({
  actionsProps,
  counterProps,
  headerProps,
  initialSelection,
  pipelineId,
  onAttach,
  onClose,
}) {
  const { t } = useTranslation()

  const {
    handleAttach,
    handleCloseTableModal,
    isCloseConfirm,
    loadData,
    setCloseConfirm,
    setNotificationListRef,
    tableColumns,
  } = useAttachTasksModal({
    initialSelection,
    pipelineId,
    onAttach,
    onClose,
  })

  const {
    canShowSearchInput,
    checkIsItemSelected,
    exclude,
    handleChangePagination,
    handleChangeSearchValue,
    handleClearSearch,
    handleExclude,
    handleLoadItems,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleSetOrdering,
    handleUnselectAllPages,
    isAllSelected,
    isInitiatedError,
    isInitLoading,
    isRemoveSelection,
    loading,
    notifications,
    ordering,
    pagination,
    search,
    selectAllPages,
    selected,
    tableItems,
  } = loadData

  return (
    <TableModal
      {...(canShowSearchInput ? null : { Search: null })}
      {...(counterProps
        ? { counterProps: { ...counterProps, count: pagination?.count } }
        : null)}
      initialFullScreen
      SelectionToolbar={null}
      actionsProps={{
        ...actionsProps,
        ButtonClear: false,
        buttonAttachProps: {
          ...actionsProps?.buttonAttachProps,
          isLoading: loading,
          qaName: QA_NAME_ATTACH_BTN,
          text:
            actionsProps?.buttonAttachProps?.text ||
            'Modal.AttachActivitiesAttachBtnKey',
          onClick: tableItems?.items?.length === 0 ? onClose : handleAttach,
        },
        buttonCancelProps: {
          qaName: QA_NAME_CANCEL_BTN,
          onClick: handleCloseTableModal,
        },
      }}
      contentProps={{ loading }}
      emptyStateProps={{
        EntityIcon: ActivityIcon,
        className: styles.emptyState,
        text: t('Modal.AttachActivitiesModalNoDataKey'),
      }}
      headerProps={{
        ...headerProps,
        text: headerProps?.text || 'Modal.AttachActivitiesModalTitleKey',
        onClose: handleCloseTableModal,
      }}
      isCloseConfirm={isCloseConfirm}
      isInitiatedError={isInitiatedError}
      isInitLoading={isInitLoading}
      loading={loading}
      notificationListProps={{
        ref: setNotificationListRef,
      }}
      notifications={notifications}
      paginationProps={{ pagination, onChange: handleChangePagination }}
      qaName={QA_NAME_ATTACH_TASKS_MODAL}
      searchProps={{
        value: search,
        onChange: handleChangeSearchValue,
        onClear: handleClearSearch,
      }}
      selectAllPages={selectAllPages}
      selected={selected}
      selectionToolbarProps={{
        exclude,
        pagination,
        selectAllPages,
        selected,
        onClose: handleUnselectAllPages,
        onSelectAll: handleSelectAllPages,
      }}
      setCloseConfirm={setCloseConfirm}
      tableItems={tableItems?.items}
      tableItemsCount={pagination.page}
      tableProps={{
        TableRow: AttachTasksModalTableRow,
        checkIsItemSelected,
        className: styles.table,
        columns: tableColumns,
        headerRowProps: {
          Actions: TableRowActions,
          actionsProps: {
            checked: isAllSelected,
            selected: isRemoveSelection,
            onChange: handleSelectAll,
          },
          ordering,
          resizable: false,
          withCellBorder: false,
          onSetOrdering: handleSetOrdering,
        },
        items: tableItems?.items,
        rowProps: {
          onSelect: selectAllPages ? handleExclude : handleSelect,
        },
      }}
      onApplyConfirmModal={onClose}
      onRefresh={handleLoadItems}
      onTableModalClose={handleCloseTableModal}
    />
  )
}

export default AttachTasksModal
